import React from 'react';

import './Card11.css';

const Card11 = props => {
  return (
    <div className={`card11 ${props.className}`} style={props.style}>
      {props.children}
    </div>
  );
};

export default Card11;
